import { render, staticRenderFns } from "./FluxoMensal.vue?vue&type=template&id=51728a10&"
import script from "./FluxoMensal.vue?vue&type=script&lang=js&"
export * from "./FluxoMensal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports